import React, { useMemo } from "react";
import { Box, Typography, GlobalStyles } from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const emptyStateAnimations = (
  <GlobalStyles
    styles={{
      "@keyframes pulse-dot": {
        "0%, 100%": { opacity: 1, transform: "scale(1)" },
        "50%": { opacity: 0.4, transform: "scale(0.8)" },
      },
    }}
  />
);

export default function EmptyLeadsState() {
  const theme = useTheme();
  const refId = useMemo(() => Math.floor(Math.random() * 9000) + 1000, []);

  return (
    <Box
      sx={{
        minHeight: "60vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      {emptyStateAnimations}

      {/* ===== LOTTIE ANIMATION ===== */}
      <Box sx={{ width: 300, height: 300, mb: 3 }}>
        <DotLottieReact
          src="https://lottie.host/98d2b3b5-ce57-48cf-8a48-4120baa2ccb6/iigIDQDY5b.lottie"
          loop
          autoplay
        />
      </Box>

      <Box sx={{ textAlign: "center" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: theme.palette.text.primary,
            mb: 1,
            letterSpacing: "-0.02em",
          }}
        >
          Zero Records Found
        </Typography>

        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1.5,
            px: 2,
            py: 0.75,
            borderRadius: "50px",
            bgcolor: alpha(theme.palette.text.primary, 0.04),
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              bgcolor: theme.palette.primary.main,
              borderRadius: "50%",
              animation: "pulse-dot 2s infinite ease-in-out",
              boxShadow: `0 0 8px ${theme.palette.primary.main}`,
            }}
          />
          <Typography
            sx={{
              fontSize: "12px",
              color: theme.palette.text.secondary,
              fontWeight: 500,
            }}
          >
            Broaden your filters or search terms
          </Typography>
        </Box>
      </Box>

      {/* <Box
        sx={{
          position: "absolute",
          bottom: 40,
          display: "flex",
          gap: 3,
          opacity: 0.3,
        }}
      >
        <Typography
          sx={{ fontFamily: "monospace", fontSize: "10px", fontWeight: 700 }}
        >
          CODE: 404_EMPTY
        </Typography>
        <Typography
          sx={{ fontFamily: "monospace", fontSize: "10px", fontWeight: 700 }}
        >
          TRACE_ID: {refId}
        </Typography>
      </Box> */}
    </Box>
  );
}
